//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DefaultSnippet from "@/components/objects/public/object-snippets/Default.vue"
import EventSnippet from "@/components/objects/public/object-snippets/NewEvent.vue"

export default {
  name: "ObjectSnippet",
  props: {
    data: {
      type: Object
    },
    ownerMode: {
      type: Boolean,
      default: false
    },
    shortName: {
      type: Boolean,
      default: false
    },
    useEventSnippet: {
      type: Boolean,
      default: false
    },
    showUserName: {
      default: false,
      type: Boolean
    },
    showStats: {
      type: Boolean,
      default: true
    },
    viewName: {
      type: String,
      default: 'objects-slug'
    },
    source: {
      type: String,
    },
    viewEditName: {
      type: String,
      default: 'objects_edit'
    },
    imagePath: {
      type: Array,
      default: undefined
    },
    showCategories: {
      type: Boolean,
      required: false,
      default: () => false
    },
    showUserIcon: {
      type: Boolean,
      required: false,
      default: () => false
    },
    materialCategories: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  computed: {
    renderComponent() {
      return this.$store.state.objects.typesAndTemplates["EVENT"]["type_id"] === this.data.vistat_id ? EventSnippet : DefaultSnippet
    }
  }
}
